import Vue from 'vue';

Vue.mixin({
    methods: {
        getLocalePath(url_path) {
            let locale_url = url_path;
            let locale = window?.afConfig?.base_locale;
            if (locale) {
                locale_url = `/${locale}${locale_url}`;
            }
            console.log('LocPath '+locale_url);
            return locale_url;
        },
    },
});